import React from 'react'

export const IconErrorMsg: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width="16" height="16" x="4" y="4" fill="url(#paint0_linear_23264_16325)" rx="4" />
    <rect
      width="6.448"
      height="1.103"
      x="9.333"
      y="13.893"
      fill="#fff"
      rx="0.552"
      transform="rotate(-45 9.333 13.893)"
    />
    <rect
      width="6.448"
      height="1.103"
      x="10.114"
      y="9.333"
      fill="#fff"
      rx="0.552"
      transform="rotate(45 10.114 9.333)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23264_16325"
        x1="12"
        x2="12"
        y1="4"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9413E" />
        <stop offset="1" stopColor="#AF2F2C" />
      </linearGradient>
    </defs>
  </svg>
)
